import axios from 'axios';

class RecipientService {
    checkToken(token) {
        return axios.get('/api/check-token/' + token).then((response) => response.data);
    }

    getRecipient(token) {
        return axios.get('/api/get-recipient/' + token).then((response) => response.data);
    }

    getPrerequisites(to, from, next, checkCompleted) {
        return this.getRecipient(to.params.token).then(({sender, inquiry, recipient}) => {
            if(!recipient || !sender || !inquiry) {
                throw 'error';
            }

            if(checkCompleted && recipient.completed !== null) {
                next({ path: '/onderzoek/' + recipient.hash + '/afronden' });
            } else if(checkCompleted && inquiry.isExpired === true) {
                next({ path: '/onderzoek/' + recipient.hash + '/verlopen'});
            } else {
                next((vm) => {
                    vm.sender    = sender;
                    vm.inquiry   = inquiry;
                    vm.recipient = recipient;
                });
            }

            return {sender, inquiry, recipient};
        }).catch((error) => {
            next({path: '/'});
        })
    }

    sendResults(questions, recipient, inquiry) {
        if(!questions || questions.length === 0 || !recipient || !inquiry) {
            throw 'error';
        }

        return axios.post('/api/recipients/' + recipient.hash + '/send-inquiry', {
            questions
        }).then((response) => response.data);
    }
}

export default new RecipientService();
